import BaseView from './_BaseView.js';

export default class InstallView extends BaseView {
    static validate() {
        //Check for required
        const error = [];
        const form = $('#login.install form');
        let valid = form.isFormValid();

        const password = $('input[name="password"]');
        const passwordv = $('.passwordv').val();

        if (!valid) {
            error.push(Lang.requirede);
        }

        if (password.val() !== "" && /Weak/g.test($('.password-verdict').text())) {
            valid = false;
            error.push(Lang.weaksauce);
        }

        if (password.val() !== passwordv) {
            valid = false;
            error.push(Lang.passwordmatch);
        }

        if (!valid) {
            //Already error box?
            if ($('.aero-error-box').length === 0) {
                $('form').prepend('<div class="aero-error-box"><ul></ul></div>');
            }

            for (let i in error) {
                $('.aero-error-box ul').append('<li>' + error[i] + '</li>');
            }
        }

        return valid;
    }

    install() {
        if (InstallView.validate()) {
            $.ajax({
                url: '/api/users/install',
                data: new FormData($('#login.install form')[0]),
                method: 'post',
                contentType: false,
                processData: false
            }).done(function () {
                window.location = '/apps';
            }).fail(function () {
                if ($('.aero-error-box').length === 0) {
                    $('#login.install').prepend(`<div class="aero-error-box"><ul><li>${Lang.installna}</li></ul></div>`);
                } else {
                    $('.aero-error-box ul').append(`<li>${Lang.installna}</li>`);
                }
            });
        }
    }

    setEvents() {
        super.setEvents();

        const self = this;
        $('#login.install input[name="password"]').pwstrength();
        $('.install .sign-in').on('click', function () {
            self.install();
            return false;
        });
    }
}
